import { FormExtractorService } from "../../../shared/services/form-extractor.service";
import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_664 implements Validator {

    public static id = 'CTRL_664';
    private message = 'error.ctr_664';


    public LOG: LogService = new LogService(CTRL_664);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_664.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const firstChamp = ctrl.value.rgCtrls.firstChamp;
                const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
                const lotMarcheIters = this.formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_LotMarche_'], '_SepSep_TypeAnn_JOUE_18_SepSep_Attribution_index_');
                let controlsName = [];
                let values = [];
                for (var i = 1; i <= lotMarcheIters.size; i++) {
                    controlsName.push(firstChamp.replace('INDEX_664_1', i));
                    if (form.controls[map.get(controlsName[i - 1])].value !== '') {
                        values.push(form.controls[map.get(controlsName[i - 1])].value);
                    }
                }
                if (values.length > 0) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}